<template>
  <div class="field-option-count-input">
    <van-field label="数量" size="large">
      <template v-slot:input>
        <van-stepper v-model="value" integer :min="1" :max="storageLeft" @change="handleChange" />
      </template>
    </van-field>
  </div>
</template>
<script>
export default {
  props: {
    left: {
      type: Number,
      default: undefined,
    },
    max: [Number],
  },
  data() {
    return {
      value: 1,
      maxCountPerOrder: 100,
    };
  },
  computed: {
    storageLeft() {
      let left = Math.min(this.left, this.maxCountPerOrder);
      if (this.left === undefined) left = undefined;
      if (this.left === -1) left = this.maxCountPerOrder;
      if (this.max) {
        if (left) {
          left = Math.min(left, this.max);
        } else {
          left = 1;
        }
      }
      return left;
    },
  },
  methods: {
    handleChange(val) {
      if (this.left === undefined) {
        this.$toast.fail('请先选择日期');
        setTimeout(() => {
          this.value = 0;
        }, 0);
        return;
      }
      const count = Math.min(val, this.maxCountPerOrder);
      this.$emit('change', count);
    },
    resetCount() {
      this.value = 1;
    },
  },
};
</script>
<style lang="less" scoped></style>
